export default __webpack_public_path__ + "static/media/Atheneum.db4ae01b.png";